import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import { setCurrencyFormat } from '../../../../utils/helpers';


const CustomerTransitionBarChart = ({ height, dataToShowForDatesSelected }) => {
    const thisMonthData = {};
    const dataToPlot = []

    dataToShowForDatesSelected?.
        map((customer, index) => (
            dataToPlot.push({ 'Customer Transition': customer.webToAmazon, 'Type': 'Web To Amazon' },
                { 'Customer Transition': customer.amazonToWeb, 'Type': 'Amazon To Web' })
        ))
    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart
                width={500}
                height={300}
                data={dataToPlot}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid vertical={false} horizontal stroke="#FF0000" strokeWidth={2} />
                <XAxis dataKey="Type" />
                <YAxis type="number" />
                <Tooltip formatter={value => setCurrencyFormat(Number(value).toFixed(2), true)} />
                <Legend />
                {/* <Bar dataKey={'Total Quantity'.toString()} fill="#82ca9d" /> */}
                <Bar dataKey={'Customer Transition'.toString()} fill="#8884d8" />

            </BarChart>
        </ResponsiveContainer>
    )
}

CustomerTransitionBarChart.propTypes = {

    height: PropTypes.number.isRequired,
    dataToShowForDatesSelected: PropTypes.arrayOf({}).isRequired,
    // eslint-disable-next-line react/forbid-prop-types
};

export default React.memo(CustomerTransitionBarChart);